// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3d2De","calendarButtons":"ClockData_calendarButtons__hZ8DM"};